'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propsChanged = exports.clearFileUploads = exports.mapFileUploads = exports.getErrorMessageArray = exports.getErrorMessage = exports.getErrorsArray = exports.getErrors = exports.isValid = exports.getModelValue = exports.getFields = exports.getField = exports.getForm = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

var _every = require('lodash/every');

var _every2 = _interopRequireDefault(_every);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var REDUCER_KEY = 'forms';

var getForm = exports.getForm = function getForm(state) {
  var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var split = model.split('.');

  return (0, _get2.default)(state, [REDUCER_KEY, split[0]], {});
};

var getField = exports.getField = function getField(state) {
  var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var split = model.split('.');
  var localPath = [REDUCER_KEY, split[0], 'fields'].concat(split.slice(1).join('.'));

  return (0, _get2.default)(state, localPath, {});
};

var getFields = exports.getFields = function getFields(state) {
  var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var split = model.split('.');
  var form = (0, _get2.default)(state, [REDUCER_KEY, split[0]], {});
  var fieldPath = split.slice(1).join('.');

  if (form.fields && form.fields[fieldPath]) {
    return _defineProperty({}, fieldPath, form.fields[fieldPath]);
  } else {
    return (0, _pickBy2.default)(form.fields, function (v, k) {
      return (0, _startsWith2.default)(k, fieldPath);
    });
  }
};

var getModelValue = exports.getModelValue = function getModelValue(state) {
  var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var split = model.split('.');
  var localPath = [REDUCER_KEY, split[0], 'model'].concat(split.slice(1)).join('.');

  return (0, _get2.default)(state, localPath);
};

var isValid = exports.isValid = function isValid(state, model) {
  var fields = getFields(state, model);
  return (0, _every2.default)(fields, function (field) {
    return field.valid;
  });
};

var getErrors = exports.getErrors = function getErrors(value, validators, values, index) {
  var errors = {};

  if (validators) {
    (0, _some2.default)(validators, function (validator, key) {
      errors[key] = !!validator(value, values, index);
      return errors[key];
    });
  }

  return errors;
};

var getErrorsArray = exports.getErrorsArray = function getErrorsArray(values, validators) {
  return values.map(function (value, index) {
    return getErrors(value, validators, values, index);
  });
};

var getErrorMessage = exports.getErrorMessage = function getErrorMessage(value, messages) {
  var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var index = arguments[3];

  var message = (0, _find2.default)(messages, function (v, k) {
    return errors[k];
  });
  return typeof message === 'function' ? message(value, errors, index) : message;
};

var getErrorMessageArray = exports.getErrorMessageArray = function getErrorMessageArray(values, messages) {
  var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return values.map(function (value, index) {
    return getErrorMessage(value, messages, errors[index], index);
  }).filter(function (message) {
    return message;
  });
};

var mapFileUploads = exports.mapFileUploads = function mapFileUploads(value) {
  if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    if (value['__ABYSS_FILE_UPLOAD__']) {
      return window.__ABYSS_FILE_UPLOAD__[value['__ABYSS_FILE_UPLOAD__']];
    } else {
      return Array.isArray(value) ? value.map(mapFileUploads) : (0, _mapValues2.default)(value, mapFileUploads);
    }
  }

  return value;
};

var clearFileUploads = exports.clearFileUploads = function clearFileUploads() {
  Object.keys(window.__ABYSS_FILE_UPLOAD__).forEach(function (key) {
    window.URL.revokeObjectURL(key);
    delete window.__ABYSS_FILE_UPLOAD__[key];
  });
};

var propsChanged = exports.propsChanged = function propsChanged(objA, objB, props) {
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return true;
  }

  if (!props) {
    props = keysA;
  }

  for (var i = 0; i < props.length; i++) {
    if (!(0, _isEqual2.default)(objA[props[i]], objB[props[i]])) {
      return true;
    }

    if (objA[props[i]] && _typeof(objA[props[i]]) === 'object' && objB[props[i]] && _typeof(objB[props[i]]) === 'object' && Object.keys(objA[props[i]]).length !== Object.keys(objB[props[i]]).length) {
      return true;
    }
  }

  return false;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-form/lib/utils.js
// module id = 46
// module chunks = 0